/* tslint:disable */
/* eslint-disable */
/**
 * Account Settings API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CustomerNotificationPreferences
 */
export interface CustomerNotificationPreferences {
    /**
     * 
     * @type {boolean}
     * @memberof CustomerNotificationPreferences
     */
    messageNotificationViaEmail: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CustomerNotificationPreferences
     */
    messageNotificationViaPushMobile: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CustomerNotificationPreferences
     */
    projectReminderNotificationViaEmail: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CustomerNotificationPreferences
     */
    newsletterViaEmail: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CustomerNotificationPreferences
     */
    eventNotificationViaEmail: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CustomerNotificationPreferences
     */
    customerServiceDiscoveryViaEmail: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CustomerNotificationPreferences
     */
    customerServiceDiscoveryViaPhone: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CustomerNotificationPreferences
     */
    freelancerProfileSuggestionsViaEmail: boolean;
}

/**
 * Check if a given object implements the CustomerNotificationPreferences interface.
 */
export function instanceOfCustomerNotificationPreferences(value: object): value is CustomerNotificationPreferences {
    if (!('messageNotificationViaEmail' in value) || value['messageNotificationViaEmail'] === undefined) return false;
    if (!('messageNotificationViaPushMobile' in value) || value['messageNotificationViaPushMobile'] === undefined) return false;
    if (!('projectReminderNotificationViaEmail' in value) || value['projectReminderNotificationViaEmail'] === undefined) return false;
    if (!('newsletterViaEmail' in value) || value['newsletterViaEmail'] === undefined) return false;
    if (!('eventNotificationViaEmail' in value) || value['eventNotificationViaEmail'] === undefined) return false;
    if (!('customerServiceDiscoveryViaEmail' in value) || value['customerServiceDiscoveryViaEmail'] === undefined) return false;
    if (!('customerServiceDiscoveryViaPhone' in value) || value['customerServiceDiscoveryViaPhone'] === undefined) return false;
    if (!('freelancerProfileSuggestionsViaEmail' in value) || value['freelancerProfileSuggestionsViaEmail'] === undefined) return false;
    return true;
}

export function CustomerNotificationPreferencesFromJSON(json: any): CustomerNotificationPreferences {
    return CustomerNotificationPreferencesFromJSONTyped(json, false);
}

export function CustomerNotificationPreferencesFromJSONTyped(json: any, ignoreDiscriminator: boolean): CustomerNotificationPreferences {
    if (json == null) {
        return json;
    }
    return {
        
        'messageNotificationViaEmail': json['messageNotificationViaEmail'],
        'messageNotificationViaPushMobile': json['messageNotificationViaPushMobile'],
        'projectReminderNotificationViaEmail': json['projectReminderNotificationViaEmail'],
        'newsletterViaEmail': json['newsletterViaEmail'],
        'eventNotificationViaEmail': json['eventNotificationViaEmail'],
        'customerServiceDiscoveryViaEmail': json['customerServiceDiscoveryViaEmail'],
        'customerServiceDiscoveryViaPhone': json['customerServiceDiscoveryViaPhone'],
        'freelancerProfileSuggestionsViaEmail': json['freelancerProfileSuggestionsViaEmail'],
    };
}

export function CustomerNotificationPreferencesToJSON(value?: CustomerNotificationPreferences | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'messageNotificationViaEmail': value['messageNotificationViaEmail'],
        'messageNotificationViaPushMobile': value['messageNotificationViaPushMobile'],
        'projectReminderNotificationViaEmail': value['projectReminderNotificationViaEmail'],
        'newsletterViaEmail': value['newsletterViaEmail'],
        'eventNotificationViaEmail': value['eventNotificationViaEmail'],
        'customerServiceDiscoveryViaEmail': value['customerServiceDiscoveryViaEmail'],
        'customerServiceDiscoveryViaPhone': value['customerServiceDiscoveryViaPhone'],
        'freelancerProfileSuggestionsViaEmail': value['freelancerProfileSuggestionsViaEmail'],
    };
}

